module.exports = __webpack_public_path__ + "img/Closed ticket.f6396047.png";